export default __webpack_public_path__ + "static/media/stadium-bg-sm.0a20f02e.png";